<template>
  <div class="row">
    <div class="col-12">
      <div class="tile">
        <div class="form-inline">
          <admin-user-select v-if="!user" class="mr-1 mb-1" :model="filterFormModel" attribute="user"
                             :place-holder="$t('translator')"></admin-user-select>
          <form-select :model="filterFormModel" attribute="status" :options="[
              {value: null, text: $t('all')},
              {value: 'pending', text: $t('pending')},
              {value: 'confirmed', text: $t('confirmed')},
              {value: 'canceled', text: $t('canceled')}
            ]" class="mr-1 mb-1"></form-select>
          <form-select :model="filterFormModel" attribute="time" :options="[
              {value: 'createTime', text: $t('filterByCreateTime')},
              {value: 'confirmTime', text: $t('filterByConfirmTime')},
              {value: 'cancelTime', text: $t('filterByCancelTime')}
          ]" class="mr-1 mb-1" @change="load"></form-select>
          <time-range-picker :model="filterFormModel" :label="$t(filterFormModel.time)" class="mr-1 mb-1"
                             :defaultShortcut="8" />

          <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
          <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
        </div>
      </div>

      <div class="c-paging clearfix">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <div class="c-paging__right">
          <div class="c-paging__numbers">
            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                          v-model="filterFormModel.page" :total-rows="itemCount"
                          :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="items.length">
      <div class="c-smart-table tile">
        <div class="row c-smart-table__title">
          <div class="col-lg-4">{{ $t('info') }}</div>
          <div class="col-lg-4">{{ $t('content') }}</div>
          <div class="col-lg-4">{{ $t('time') }}</div>
        </div>
        <div class="row" v-for="item in items" :key="item._id">
          <div class="col-lg-4">
            <div v-if="item.user">
              <b>{{ $t('translator') }}: </b> {{ item.user.name }}
            </div>
            <div v-if="item.row">
              <b>{{ $t('callId') }}: </b> {{ item.row.call }}
            </div>
            <div>
              <b>{{ $t('type') }}: </b> {{ $t(item.type) }}
            </div>
          </div>
          <div class="col-lg-4">
            <div>
              <span v-if="!item.cancelTime && !item.confirmTime"
                    class="mr-1 badge badge-warning">{{ $t('pending') }}</span>
              <span v-else-if="item.cancelTime" class="mr-1 badge badge-danger">{{ $t('canceled') }}</span>
              <span v-else-if="item.confirmTime" class="mr-1 badge badge-success">{{ $t('confirmed') }}</span>
              <span v-if="item.note" class="text-gray-999 small">{{ item.note }}</span>
            </div>
            <div v-if="item.transcripts && item.transcripts.length">
              <div
                :class="[(item.transcripts.join(', ').length <= 120 && item.transcripts.length <= 5) || item.showMore ? 'c-voice-text active' : 'c-voice-text']">
                <div class="c-voice-text__content" v-html="getTranscripts(item.transcripts)"></div>
                <div v-if="item.transcripts.join(', ').length > 120 || item.transcripts.length > 5"
                     class="c-voice-text__btn" @click="item.showMore = !item.showMore">
                  <span class="c-voice-text__expand">{{ $t('seeMore') }}</span>
                  <span class="c-voice-text__close">{{ $t('collapse') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div>
              <b>{{ $t('createTime') }}: </b> {{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}
            </div>
            <div>
              <b>{{ $t('updateTime') }}: </b>
              <span v-if="item.updateTime">{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              <span v-else class="text-secondary">{{ $t('notUpdated') }}</span>
            </div>
            <div v-if="item.confirmTime">
              <div>
                <b>{{ $t('confirmTime') }}: </b> {{ item.confirmTime | moment('DD/MM/YYYY HH:mm:ss') }}
              </div>
              <div v-if="item.approveBy">
                <b>{{ $t('confirmBy') }}: </b> {{ item.approveBy.name }}
              </div>
            </div>
            <div v-if="item.cancelTime">
              <div>
                <b>{{ $t('cancelTime') }}: </b> {{ item.cancelTime | moment('DD/MM/YYYY HH:mm:ss') }}
              </div>
              <div v-if="item.approveBy">
                <b>{{ $t('cancelBy') }}: </b> {{ item.approveBy.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center text-danger" v-if="!items.length">
      <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
      <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
    </div>
    <div class="col-12" v-if="itemCount">
      <div class="c-paging__count" v-if="itemCount">
        {{ $t('found', [itemCount]) }}
      </div>
      <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                    v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                    @input="load">
      </b-pagination>
    </div>
  </div>
</template>
<script>
import List from '@/mixins/List'
import TimeRangePicker from '@/components/TimeRangePicker.vue'
import AdminUserSelect from '@/components/AdminUserSelect.vue'

export default {
  props: ['user'],
  components: { AdminUserSelect, TimeRangePicker },
  mixins: [List],
  data: function() {
    return {
      service: '/admin-call/history',
      tab: 0,
      defaultFilterFormModel: {
        user: this.user ? this.user._id : null,
        status: null,
        time: 'createTime'
      },
      autoLoad: true
    }
  },
  i18n: {
    messages: {
      en: {
        pending: 'Pending',
        canceled: 'Canceled',
        confirmed: 'Confirmed',
        confirmTime: 'Confirm time',
        cancelTime: 'Cancel time',
        confirmBy: 'Confirm by',
        cancelBy: 'Cancel by',
        seeMore: 'See more',
        collapse: 'Collapse',
        leftOne: 'Staff side - 1st translation',
        leftTwo: 'Staff side - 2nd translation',
        rightOne: 'Guest side - 1st translation',
        rightTwo: 'Guest side - 2nd translation',
        content: 'Translated content',
        translator: 'Translator',
        approveBy: 'Approve by',
        filterByCreateTime: 'Filter by create time',
        filterByConfirmTime: 'Filter by confirm time',
        filterByCancelTime: 'Filter by cancel time',
        callId: 'Call ID'
      },
      vi: {
        pending: 'Chờ duyệt',
        canceled: 'Từ chối',
        confirmed: 'Đã duyệt',
        confirmTime: 'Duyệt lúc',
        cancelTime: 'Từ chối lúc',
        confirmBy: 'Nhân viên duyệt',
        cancelBy: 'Nhân viên từ chối',
        seeMore: 'Xem thêm',
        collapse: 'Thu gọn',
        leftOne: 'Bên nhân viên - Bản dịch lần 1',
        leftTwo: 'Bên nhân viên - Bản dịch lần 2',
        rightOne: 'Bên khách - Bản dịch lần 1',
        rightTwo: 'Bên khách - Bản dịch lần 2',
        content: 'Nội dung biên dịch',
        translator: 'Người biên dịch',
        approveBy: 'Người kiểm duyệt',
        filterByCreateTime: 'Lọc theo thời gian tạo',
        filterByConfirmTime: 'Lọc theo thời gian duyệt',
        filterByCancelTime: 'Lọc theo thời gian từ chối',
        callId: 'ID cuộc gọi'
      }
    }
  },
  methods: {
    apply: function(data) {
      for (let item of data.docs) {
        item.showMore = false
      }
      this.items = data.docs
      this.itemCount = data.totalDocs
    },
    getTranscripts(transcripts) {
      if (!transcripts || !transcripts) {
        return ''
      }
      return `<ul class="mb-0"><li>${transcripts.join('</li><li>')}</li></ul>`
    }
  }
}
</script>

<style lang="scss">
$white: #FFF;
$primary-color: #1284e7 !default;
@mixin transition-all($s) {
  -webkit-transition: all $s ease;
  -moz-transition: all $s ease;
  transition: all $s ease;
}

@mixin linear-gradient($poi, $color1, $color2) {
  background: linear-gradient($poi, $color1, $color2);
  background: -webkit-linear-gradient($poi, $color1, $color2); /* Firefox 3.6+ */
  background: -moz-linear-gradient($poi, $color1, $color2); /* IE 10 */
  background: -ms-linear-gradient($poi, $color1, $color2); /* Opera 11.10+ */
  background: -o-linear-gradient($poi, $color1, $color2);
}

.c-voice-text {
  &__content {
    font-size: 14px;
    line-height: 18px;
    overflow: hidden;
    max-height: 18px * 3;
    position: relative;
    z-index: 1;
    @include transition-all(0.2s);

    &:after {
      content: "";
      position: absolute;
      z-index: 2;
      bottom: 0;
      right: 0;
      left: 0;
      height: 18px;
      @include linear-gradient(to right, transparent, $white);
    }

    p {
      margin: 0;
    }

    .text-gray-999 {
      position: relative;
      z-index: 4;
    }
  }

  &__btn {
    padding-top: 5px;
    text-align: left;
  }

  &__close {
    display: none;
    cursor: pointer;
    margin-right: 7px;
    font-size: 12px;
    color: $primary-color;
  }

  &__expand {
    cursor: pointer;
    margin-right: 7px;
    font-size: 12px;
    color: $primary-color;
  }

  &.active {
    .c-voice-text__content {
      max-height: none;

      &:after {
        display: none;
      }
    }

    .c-voice-text__expand {
      display: none;
    }

    .c-voice-text__close {
      display: inline;
    }
  }
}
</style>